export const list = [
    { id: 1, name: "Testimonial", count: 0 },
    { id: 2, name: "Pending ", count: 0 },
  ];
  